import React, {useState, useEffect} from "react";
import {useMap} from "react-leaflet";

export default function FlyObjectPanelButton(props) {
    const [userTipo, setUserTipo] = useState(props.userTipo);
    const [stateButton, setStateButton] = useState(props.stateButton);
    const [sn, setSn] = useState(props.sn);

    const [isButtonDisabled, setButtonDisabled] = useState(false);

    const clickButton =  (sn) => {
        setStateButton(!stateButton);
        props.setMainFlyObject(sn, stateButton, sn?.alias);

        props.cambiaButton(sn, !stateButton, sn?.alias);
    };

    useEffect(() => {
        setStateButton(props.stateButton);
    }, [props.stateButton]);

    useEffect(() => {setUserTipo(props.userTipo)}, [props.userTipo]);

/*
    useEffect(() => {
        // Disabilita i bottoni all'avvio della componente
        setButtonDisabled(true);
    
        // Attendi un secondo (1000 millisecondi) e poi abilita i bottoni
        const timeoutId = setTimeout(() => {
          setButtonDisabled(false);
        }, 1000);
    
        // Pulisci il timeout quando la componente si smonta
        return () => clearTimeout(timeoutId);
      }, []); // L'array vuoto [] indica che questo effetto viene eseguito solo al montaggio della componente
*/
      // per rimettere i bottoni disabled per 1 secondo, decommentare la parte -----> disabled={isButtonDisabled} e l'effetto sopra>

    return (<div className="p-1 w-100">
        <button className={"btn-block btn " + (stateButton ? " btn-warning" : "")} onClick={ () => { clickButton(sn)}} /*disabled={isButtonDisabled}*/>

            <div className="d-flex flex-row">
                <div className="mr-auto"><img src={props.htkBackend + "/storage/" + sn?.iconTD} width="22" className="p-1" /></div>
                <div className="">{userTipo==3 ? (sn?.marca ) : ("")} <i className="fa-solid fa-angles-right"></i> {sn?.alias}</div>

            </div>
        </button>
    </div>);
}
